export const lastModified = "2026-10-25";
